export * from './photos.mock';
export * from './tours.mock';
